import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_icon = _resolveComponent("icon");
  var _component_el_menu_item = _resolveComponent("el-menu-item");
  var _component_el_sub_menu = _resolveComponent("el-sub-menu");
  var _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createBlock(_component_el_menu, {
    "text-color": "rgb(178 183 255 / 1)",
    "active-text-color": "rgb(255 255 255 / 1)",
    "default-active": _ctx.$page.url.substr(1),
    "default-openeds": [_ctx.$page.url.substr(0, $options.getPosition(_ctx.$page.url, '/', 2))],
    "background-color": "rgb(47 54 95 / 1)",
    style: {
      "border": "0px"
    },
    onSelect: $options.gotoReport
  }, {
    "default": _withCtx(function () {
      return [_ctx.$store.can.organizations ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: "/organizations"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('organizations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('organizations') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Registrations", 2)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.account ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "/account"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('account') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('account') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Accounts", 2)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can['user.management'] ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 2,
        index: "/user_management"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('user_management') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('user_management') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Users", 2)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "/user_management/access"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('user_management/access') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "User Access", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/user_management/resource_mapping"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('user_management/resource_mapping') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Resource Mapping", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/user_management/hierarchy"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('user_management/hierarchy') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Resource Hierarchy", 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.campaigns ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 3,
        index: "/campaigns || /drafts || /smtp"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "users",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('campaigns') || $options.isUrl('drafts') || $options.isUrl('smtp') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('campaigns') || $options.isUrl('drafts') || $options.isUrl('smtp') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Campaign Settings", 2)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "/campaigns"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('campaigns') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Settings", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/drafts/index"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('drafts/index') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Drafts", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/smtp"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('smtp') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Smtp", 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.activity ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 4,
        index: "/campaign_activity"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "users",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('campaign_activity') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('campaign_activity') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Campaign Activity", 2)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "/campaign_activity/details"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('campaign_activity/details') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Details", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/campaign_activity/overview"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('campaign_activity/overview') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Overview", 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.research ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 5,
        index: "/tenant"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('tenant') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('tenant') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Research Data", 2)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "/tenant/report"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('tenant/report') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Research Data", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/tenant/parameter"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('tenant/parameter') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Data Breakup", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/tenant/solution"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('tenant/solution') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Lead Conversions", 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.data ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 6,
        index: "/data"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('data') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('data') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Data Creation", 2)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "/data/account_stat"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('data/account_stat') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Account Level", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/data/user_stat"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('data/user_stat') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Resource Wise", 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.leaderboard || _ctx.$store.can['leaderboard.mapping'] ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 7,
        index: "/leaderboard"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('leaderboard') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('leaderboard') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Leader Board", 2)];
        }),
        "default": _withCtx(function () {
          return [_ctx.$store.can.leaderboard ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: "/leaderboard/index"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('leaderboard/index') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Leader Board", 2)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.$store.can['leaderboard.mapping'] ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: "/leaderboard/mapping"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('leaderboard/mapping') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Mapping", 2)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.target ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 8,
        index: "/target"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('target') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('target') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Campaign Target", 2)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "/target/index"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('target/index') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Campaign Target", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/target/account_report"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('target/account_report') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "Account Report", 2)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/target/user_report"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.isUrl('target/user_report') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
              }, "User Report", 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.transfer ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 9,
        index: "/transfer/index"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('transfer/index') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('transfer/index') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Lead Transfer", 2)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.can.health ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 10,
        index: "/system_health"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_icon, {
            name: "office",
            "class": _normalizeClass(["mr-2 w-4 h-4", $options.isUrl('system_health') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'])
          }, null, 8, ["class"]), _createElementVNode("div", {
            "class": _normalizeClass($options.isUrl('system_health') ? 'text-white' : 'text-indigo-300 group-hover:text-white')
          }, "Health", 2)];
        }),
        _: 1
      })) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["default-active", "default-openeds", "onSelect"]);
}